import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { getAction } from '@/api/manage';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export var pageMixin = {
  data: function data() {
    return {
      maxPage: 10,
      //最大页码数
      searchCount: false //是否请求总条数

    };
  },
  mounted: function mounted() {
    // 默认请求一百条数据，来判断最少页数
    this.getPages(1, 100);
  },
  methods: {
    // 选中当前页
    setPage: function setPage(data) {
      // 如果data.maxPage存在证明当前选中页是页码组最后一页，即将更新页码组，更新前需要判断下一页有无数据
      if (data.maxPage) {
        this.getPages(data.maxPage, data.pageSize);
      } else {
        // 否则就是正常请求当页数据
        this.queryParam.current = data.current;
        this.queryParam.size = data.pageSize;
        this.loadData(null, true);
      }
    },
    // 获取下一页数据
    getPages: function getPages(maxPage, size) {
      var that = this;
      var params = this.getQueryParams ? this.getQueryParams() : _objectSpread({}, this.queryParam); //查询条件

      params.current = maxPage;
      params.size = size; // 请求时禁用按钮,防止多次连续点击

      that.$refs.page.disabled = true; // 如果不是第一次请求前一百条（因为会重复loading），加loading

      if (maxPage != 1) {
        that.loading = true;
      }

      var url = '';

      if (this.url) {
        if (this.url.list) {
          url = this.url.list;
        } else {
          url = this.url;
        }
      } else {
        url = this.pagePath;
      }

      getAction(url, params).then(function (res) {
        if (res.success) {
          if (res.result.records.length == 0) {
            // 第一次请求页码时 并且站点id不为空时 如果请求数据为空 则隐藏页码组件
            if (maxPage == 1 && (params.scopeId || params.siteId)) {
              that.$refs.page.showPage = false;
            }
          } else {
            // 当前为第一页时
            if (maxPage == 1) {
              if (params.scopeId || params.siteId) {
                that.$refs.page.showPage = true;
              }

              that.$refs.page.selectPageValue = 1; // 如果数据条数满100，最大页码就为10

              if (res.result.records.length == 100) {
                that.maxPage = 10;
              } else {
                // 否则就是不满十页，页数为总条数除以10并向上取整
                that.maxPage = Math.ceil(res.result.records.length / 10);
              }
            } else {
              // 如果当前不为第一页，则是超过十页后点击下一页的情况，根据下一页数据有无数据来判断最大页码数
              // 如果下一页数据不为空
              if (res.result.records && res.result.records.length > 0) {
                // 则最大页码数更新为当前页数
                that.maxPage = maxPage; // 当前页数+1

                that.$refs.page.selectPageValue++;
                that.dataSource = res.result.records;
              } else {
                // 否则最大页码数为当前页数-1
                that.maxPage = maxPage - 1;
              }
            }
          }
        }
      }).finally(function () {
        // 请求结束开放按钮
        that.$refs.page.disabled = false;
        that.loading = false;
      });
    }
  }
};